<template>
  <div>
    &copy; {{ currentYear }} STR Enforcement LLC
  </div>
</template>

<script>
export default {
  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  }
}
</script>
